import React, { ChangeEvent } from 'react';
import islide_logo_icon from '../../../assets/islide_logo.png';

interface IProps {
  onSubmit(email: string): void;
}

interface IState {
  mask: boolean;
  email: string;
}

export class Header extends React.Component<IProps, IState> {
  public readonly state: Readonly<IState> = {
    mask: false,
    email: ''
  };

  constructor(props: IProps) {
    super(props);
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    let scrollY: number = window.scrollY;
    if (scrollY > 317) {
      this.setState({
        mask: true
      });
    } else {
      this.setState({
        mask: false
      });
    }
  }

  handleChange(e: ChangeEvent<HTMLInputElement>) {
    this.setState({
      email: e.target.value
    });
  }

  handleSubmit() {
    this.props.onSubmit(this.state.email.trim());
  }

  render() {
    return (
      <nav
        className={[
          'navbar navbar-default navbar-fixed-top',
          this.state.mask ? 'navbar-mask' : ''
        ].join(' ')}
      >
        <div className="container">
          <div className="navbar-header">
            <img className="logo" src={islide_logo_icon} alt="logo" />
          </div>
          <div className="collapse navbar-collapse">
            <ul
              className="nav navbar-nav navbar-right nav-ul-right"
              style={{ display: 'block', width: '600px' }}
            >
              <div
                className="newsletter-form"
                style={{ position: 'relative', top: '7px' }}
              >
                <input
                  className="email-newsletter"
                  placeholder="Enter Your Email Address"
                  onChange={this.handleChange.bind(this)}
                />
                <button
                  className="email-btn"
                  onClick={this.handleSubmit.bind(this)}
                >
                  GET IT NOW
                </button>
              </div>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}
